import {
  GET_DASHBOARD_ANNOUNCEMENT_LOADING,
  GET_DASHBOARD_ANNOUNCEMENT_SUCCESS,
  GET_DASHBOARD_ANNOUNCEMENT_ERROR,
} from "../../../constant/actionTypes";
const dashboardAnnouncementsReducer = (
  state = {
    loading: true,
  },
  action
) => {
  switch (action.type) {
    case GET_DASHBOARD_ANNOUNCEMENT_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case GET_DASHBOARD_ANNOUNCEMENT_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case GET_DASHBOARD_ANNOUNCEMENT_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default dashboardAnnouncementsReducer;
